export default {
  verbiage: {},
  locale: null
}